import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../globals';
import { Message } from 'primeng/primeng';
import { IProgressReportBasicData } from '../../../Models/IProgressReportBasicData';
import { IFormGoalsAndBenchmarks } from "../../../Models/Forms/IFormGoalsAndBenchmarks";
import { FormGoalsAndBenchmarksService } from "../../../Services/FormGoalsAndBenchmarksService";
import { IStudentMinimal } from '../../../Models/IStudentMinimal'
import { IIepInstance } from '../../../Models/IIepInstance';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { ReportService } from 'src/app/Services/ReportService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { Observable, throwError, of } from "rxjs";
import { SpinnerBase } from '../../Base/SpinnerBase';
import { IepService } from '../../../Services/IepService';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportPDF } from 'src/app/Models/IReportPDF';

@Component({
  selector: 'IEPProgressReport',
  templateUrl: './IEPProgressReport.component.html',
  styleUrls: ['./IEPProgressReport.component.css']
})

export class IEPProgressReportComponent extends SpinnerBase implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  messages: Message[];
  studentInfo: IStudentMinimal;
  IepInstance: IIepInstance;
  _formGoalsAndBenchmarksService: FormGoalsAndBenchmarksService;
  _iepService: IepService;
  _lookupService: LookupService;
  goalsAndBenchmarksDB: any = [];
  lookupProgressAttained: ILookupBase[];
  reportParamArray: IReportParameter[];
  goalId: number;
  annualProgressId: string;
  benchAProgressId: string;
  benchBProgressId: string;
  viewGoal: boolean;
  annualGoalEdit: boolean;
  benchmarkAEdit: boolean;
  benchmarkBEdit: boolean;
  startDate: Date;
  endDate: Date;
  primaryDisability: string;
  showSpinner: boolean = false;

  constructor(
    globals: Globals, reportService: ReportService,
    formGoalsAndBenchmarksService: FormGoalsAndBenchmarksService,
    iepService: IepService,
    @Inject('BASE_URL') baseUrl: string,
    lookupService: LookupService) {
    super(reportService);
    this._formGoalsAndBenchmarksService = formGoalsAndBenchmarksService;
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.studentMinimal;
    this._lookupService = lookupService;
  }

  ngOnInit(): void {
    this.goalId = null;
    this.annualGoalEdit = false;
    this.benchmarkAEdit = false;
    this.benchmarkBEdit = false;
  }

  getSelectedGoal(goalId) {
    this.clearMessages();
    this.goalId = goalId;

    this.studentInfo = this._myGlobals.studentMinimal; //refresh to reflect updated global value

    this._formGoalsAndBenchmarksService.getFormGoalsAndBenchmarks(goalId)
      .subscribe((res: IFormGoalsAndBenchmarks) => {
        this.goalsAndBenchmarksDB = res;
        this.goalsAndBenchmarksDB.annualDateSent = this.goalsAndBenchmarksDB.annualDateSent == null ? null : new Date(this.goalsAndBenchmarksDB.annualDateSent);
        this.goalsAndBenchmarksDB.benchmarkASent = this.goalsAndBenchmarksDB.benchmarkASent == null ? null : new Date(this.goalsAndBenchmarksDB.benchmarkASent);
        this.goalsAndBenchmarksDB.benchmarkBSent = this.goalsAndBenchmarksDB.benchmarkBSent == null ? null : new Date(this.goalsAndBenchmarksDB.benchmarkBSent);
        this.goalsAndBenchmarksDB.annualGoalByFirst = this.goalsAndBenchmarksDB.annualGoalByFirst == null ? null : new Date(this.goalsAndBenchmarksDB.annualGoalByFirst);
        this.goalsAndBenchmarksDB.firstBenchmarkObjectiveByFirst = this.goalsAndBenchmarksDB.firstBenchmarkObjectiveByFirst == null ? null : new Date(this.goalsAndBenchmarksDB.firstBenchmarkObjectiveByFirst);
        this.goalsAndBenchmarksDB.secondBenchmarkObjectiveByFirst = this.goalsAndBenchmarksDB.secondBenchmarkObjectiveByFirst == null ? null : new Date(this.goalsAndBenchmarksDB.secondBenchmarkObjectiveByFirst);
        this.annualProgressId = this.goalsAndBenchmarksDB.annualProgress == null ? null : this.goalsAndBenchmarksDB.annualProgress.toString();
        this.benchAProgressId = this.goalsAndBenchmarksDB.benchAProgress == null ? null : this.goalsAndBenchmarksDB.benchAProgress.toString();
        this.benchBProgressId = this.goalsAndBenchmarksDB.benchBProgress == null ? null : this.goalsAndBenchmarksDB.benchBProgress.toString();

        this.viewGoal = true;
        this.LoadIepInstance();
        this.LoadLookup();
        this.annualGoalEdit = false;
        this.benchmarkAEdit = false;
        this.benchmarkBEdit = false;
        this.scrollToBottom();
      },
        err => this.errorHandler(err)
    );
  }

  scrollToBottom(): void {
    let pos = window.pageYOffset;
    //Scroll the from to position horizontally 0 and vertically 600
    if (pos < 600) {
      window.scrollTo(0, 600);
    }
  }

  LoadIepInstance() {
    this._iepService.getIepInstance(this._baseUrl + 'api/Iep/GetIepInstance?iepInstanceId=' + this.goalsAndBenchmarksDB.iepInstanceId).subscribe((res: IIepInstance) => {
      this.IepInstance = res;
      this.IepInstance.annualDueDate = this.IepInstance.annualDueDate == null ? null : new Date(this.IepInstance.annualDueDate);
      this.IepInstance.triAnnualDueDate = this.IepInstance.triAnnualDueDate == null ? null : new Date(this.IepInstance.triAnnualDueDate);
      this._myGlobals.refreshSpedStudentDemographics(this.IepInstance.id);

    },
      err => console.error(err)
    );
  }

  //Save the Goals And Benchmarks
  saveGoal() {
    this.clearMessages();
    this.goalsAndBenchmarksDB.annualProgress = this.annualProgressId == null ? null : parseInt(this.annualProgressId);
    this.goalsAndBenchmarksDB.benchAProgress = this.benchAProgressId == null ? null : parseInt(this.benchAProgressId);
    this.goalsAndBenchmarksDB.benchBProgress = this.benchBProgressId == null ? null : parseInt(this.benchBProgressId);
    this.goalsAndBenchmarksDB.updatedBy = this._myGlobals.spedSecurityUser.userNameEmail;
    //update values
    this._formGoalsAndBenchmarksService.insertUpdateFormGoalsAndBenchmarks(this.goalsAndBenchmarksDB)
      .subscribe((res: IFormGoalsAndBenchmarks) => {
        let successMessage: Message = { severity: 'success', summary: 'Record Saved Successfully', detail: res.id.toString() }
        this.addMessage(successMessage);
        this.annualGoalEdit = false;
        this.benchmarkAEdit = false;
        this.benchmarkBEdit = false;
        this.getSelectedGoal(res.id);
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
        }
      )
  }

  LoadLookup() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Disability]).subscribe((res: ILookupBase[]) => {
      var obj = res.filter(x => x.value === this._myGlobals.primaryDisibility);
      this.primaryDisability = obj.map(x => x.label).toString();
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ProgressAttained]).subscribe((res: ILookupBase[]) => {
      this.lookupProgressAttained = [{ value: null, label: "[Select One]", shortText: null, updatedOn: null }].concat(res);
    },
      err => console.error(err)
    );
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [];
    this.messages = [...this.messages, msg];
  }
  editAnnualGoal() {
    this.annualGoalEdit = true;
    this.benchmarkAEdit = false;
    this.benchmarkBEdit = false;
  }

  editBenchmarkA() {
    this.annualGoalEdit = false;
    this.benchmarkAEdit = true;
    this.benchmarkBEdit = false;
  }

  editBenchmarkB() {
    this.annualGoalEdit = false;
    this.benchmarkAEdit = false;
    this.benchmarkBEdit = true;
  }

  clearMessages() {
    this.messages = [];
  }

  errorHandler(error: Response): Observable<any> {
    console.log(error);
    return Observable.throw(error);
  }

  populateReportParameters() {
    let goalsAndBenchmark = this.goalsAndBenchmarksDB as IFormGoalsAndBenchmarks;

    let reportName = goalsAndBenchmark.rdlFileNameEnglish.replace("GoalsAndBenchmarks", "ProgressReport");
    this.reportParamArray = [] as IReportParameter[];
    this.reportParamArray.push(
      { parameterName: 'AnnualDueDate', parameterValue: this.IepInstance.annualDueDate == null ? '' : this.IepInstance.annualDueDate.toLocaleDateString() },

      { parameterName: 'AnnualGoal', parameterValue: goalsAndBenchmark.annualGoalComments == null ? '' : goalsAndBenchmark.annualGoalComments },
      { parameterName: 'AnnualGoalProgress', parameterValue: goalsAndBenchmark.annualProgressComment == null ? '' : goalsAndBenchmark.annualProgressComment },
      { parameterName: 'AnnualGoalProgressAttained', parameterValue: goalsAndBenchmark.annualProgressText },
      { parameterName: 'AnnualGoalSentDate', parameterValue: goalsAndBenchmark.annualDateSent == null ? '' : goalsAndBenchmark.annualDateSent.toLocaleDateString() },
      { parameterName: 'AnnualGoalTargetDate', parameterValue: goalsAndBenchmark.annualGoalByFirst == null ? '' : goalsAndBenchmark.annualGoalByFirst.toLocaleDateString() },

      { parameterName: 'BenchmarkA', parameterValue: goalsAndBenchmark.firstBenchmarkObjectiveComments == null ? '' : goalsAndBenchmark.firstBenchmarkObjectiveComments },
      { parameterName: 'BenchmarkAProgress', parameterValue: goalsAndBenchmark.benchAProgressComment == null ? '' : goalsAndBenchmark.benchAProgressComment },
      { parameterName: 'BenchmarkAProgressAttained', parameterValue: goalsAndBenchmark.benchAProgressText },
      { parameterName: 'BenchmarkASentDate', parameterValue: goalsAndBenchmark.benchmarkASent == null ? '' : goalsAndBenchmark.benchmarkASent.toLocaleDateString() },
      { parameterName: 'BenchmarkATargetDate', parameterValue: goalsAndBenchmark.firstBenchmarkObjectiveByFirst == null ? '' : goalsAndBenchmark.firstBenchmarkObjectiveByFirst.toLocaleDateString() },

      { parameterName: 'BenchmarkB', parameterValue: goalsAndBenchmark.secondBenchmarkObjectiveComments == null ? '' : goalsAndBenchmark.secondBenchmarkObjectiveComments },
      { parameterName: 'BenchmarkBProgress', parameterValue: goalsAndBenchmark.benchBProgressComment == null ? '' : goalsAndBenchmark.benchBProgressComment  },
      { parameterName: 'BenchmarkBProgressAttained', parameterValue: goalsAndBenchmark.benchBProgressText },
      { parameterName: 'BenchmarkBSentDate', parameterValue: goalsAndBenchmark.benchmarkBSent == null ? '' : goalsAndBenchmark.benchmarkBSent.toLocaleDateString() },
      { parameterName: 'BenchmarkBTargetDate', parameterValue: goalsAndBenchmark.secondBenchmarkObjectiveByFirst == null ? '' : goalsAndBenchmark.secondBenchmarkObjectiveByFirst.toLocaleDateString() },

      { parameterName: 'BirthDate', parameterValue: new Date(this._myGlobals.spedStudentDemographics.dob).toLocaleDateString() },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'isDraft', parameterValue: 'False' },
      { parameterName: 'PrimaryDisability', parameterValue: this._myGlobals.spedStudentDemographics.primaryDisabilityName },
      { parameterName: 'PupilFirstName', parameterValue: this._myGlobals.spedStudentDemographics.firstName },
      { parameterName: 'PupilLastName', parameterValue: this._myGlobals.spedStudentDemographics.lastName },
      { parameterName: 'ReportPath', parameterValue: 'IEP_ProgressReport_English' },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'TriAnnualDueDate', parameterValue: this.IepInstance.triAnnualDueDate == null ? '' : this.IepInstance.triAnnualDueDate.toLocaleDateString() }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    let reportName = this.goalsAndBenchmarksDB.rdlFileNameEnglish.replace("GoalsAndBenchmarks", "ProgressReport");
    this.showSpinner = true;
    let reportRequest = {} as IReportRequest;
    reportRequest.addCommonReportParametersInController = true;
    reportRequest.prefix = 'EPIC_AeriesEpicDev_REPORTS';
    reportRequest.reportFileName = "IEP_ProgressReport_English";
    reportRequest.reportSpecificParameterArray = this.reportParamArray;

    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
    },
      err => {
         this.showSpinner = false;
        console.error(err);
      }
    );

  }

}
